import React, { useEffect, useRef, useState } from 'react'
import { BiLeftArrow, BiRightArrow } from 'react-icons/bi';
import { NewButton } from './NewButton';

import styles from './SpeakerModal.module.css'
export const SpeakerModal = ({ speakers, speakerIdx, handleClose }) => {
   const [modalInfo, setModalInfo] = useState({});
   const [modalIdx, setModalIdx] = useState({});
   const [arrowsStyle, setArrowsStyle] = useState({ left: { opacity: 0.75 }, right: { opacity: 0.75 } })
   const modalRef = useRef(null);
   useEffect(() => {
      modalRef.current.focus()
      setModalIdx(speakerIdx)
      setModalInfo(data(speakerIdx));
   }, [])// eslint-disable-line 
   const data = (idx) => {
      return {
         image: speakers[idx]?.headshot_url,
         name: speakers[idx]?.firstname + " " + speakers[idx]?.lastname,
         job: speakers[idx]?.jobtitle,
         company: speakers[idx]?.company,
         bio: speakers[idx]?.bio,
         website: speakers[idx]?.website,
         linkedin: speakers[idx]?.linkedin_uid
      }
   }
   const arrowsControl = (dir) => {
      switch (dir) {
         case 'left':
            setArrowsStyle({ ...arrowsStyle, left: { opacity: 1, fontSize: '2.55em' } })
            setTimeout(() => setArrowsStyle({ ...arrowsStyle, left: { opacity: 0.75, fontSize: '2.5em' } }), 100)
            break;
         case 'right':
            setArrowsStyle({ ...arrowsStyle, right: { opacity: 1, fontSize: '2.55em' } })
            setTimeout(() => setArrowsStyle({ ...arrowsStyle, right: { opacity: 0.75, fontSize: '2.5em' } }), 100)
            break;
         default:
            break;
      }
   }
   // events
   const handelArrowClick = (e, diff) => {
      e.stopPropagation()
      if ((modalIdx === 0 && diff === -1) || (modalIdx === speakers.length - 1 && diff === 1)) {
         return
      }
      setModalInfo(data(modalIdx + diff));
      setModalIdx(prev => prev + diff)
      arrowsControl(diff === 1 ? 'right' : 'left')
   }
   const handleKeyDown = (e) => {
      switch (e.key) {
         case 'ArrowLeft':
            if (modalIdx === 0) return
            handelArrowClick(e, -1);
            arrowsControl('left')
            break;
         case 'ArrowRight':
            if (modalIdx === speakers.length - 1) return
            handelArrowClick(e, 1);
            arrowsControl('right')
            break;
         default:
            break;
      }
   };
   if (!modalInfo) return <></>
   return (
      <div tabIndex="0" onKeyDown={handleKeyDown} ref={modalRef} className={styles.speakerModal}>
         <section>
            <img src={modalInfo.image} alt='head-shot' />
            <h6>{modalInfo.name}</h6>
            <h5>{modalInfo.job}</h5>
            <h4>{modalInfo.company}</h4>
         </section>

         {speakers.length > 1 && <BiLeftArrow style={arrowsStyle.left} className={styles.arrowLeft} onClick={(e) => handelArrowClick(e, -1)} />}
         {speakers.length > 1 && <BiRightArrow style={arrowsStyle.right} className={styles.arrowRight} onClick={(e) => handelArrowClick(e, 1)} />}

         <section>
            <p>{modalInfo.bio}</p>
            <div className={styles.btns}>
               {
                  modalInfo.website &&
                  <a href={modalInfo.website} target='_blank' rel='noreferrer'>
                     <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_2_1286)">
                           <path d="M0 18.1055C0 13.3037 1.90754 8.69844 5.30299 5.30299C8.69844 1.90754 13.3037 0 18.1055 0C22.9074 0 27.5127 1.90754 30.9081 5.30299C34.3036 8.69844 36.2111 13.3037 36.2111 18.1055C36.2111 22.9074 34.3036 27.5127 30.9081 30.9081C27.5127 34.3036 22.9074 36.2111 18.1055 36.2111C13.3037 36.2111 8.69844 34.3036 5.30299 30.9081C1.90754 27.5127 0 22.9074 0 18.1055ZM16.974 2.43746C15.4576 2.89915 13.9526 4.29328 12.7033 6.63568C12.2917 7.41444 11.9377 8.2223 11.6441 9.05277H16.974V2.43746ZM9.25646 9.05277C9.63367 7.85061 10.1184 6.68487 10.7049 5.56972C11.0962 4.82978 11.5481 4.12351 12.056 3.45816C9.25194 4.62105 6.83938 6.56241 5.1035 9.05277H9.25646ZM7.93928 16.974C8.00718 14.9891 8.2516 13.0858 8.6454 11.316H3.78859C2.94468 13.0927 2.44111 15.0118 2.30393 16.974H7.93928ZM10.9697 11.316C10.5246 13.1713 10.2683 15.067 10.2047 16.974H16.974V11.316H10.9697ZM19.2371 11.316V16.974H26.0041C25.9414 15.0671 25.6858 13.1714 25.2414 11.316H19.2371ZM10.207 19.2371C10.2698 21.144 10.5253 23.0397 10.9697 24.8951H16.974V19.2371H10.207ZM19.2371 19.2371V24.8951H25.2414C25.6646 23.1638 25.9339 21.2559 26.0064 19.2371H19.2371ZM11.6441 27.1583C11.9565 28.0319 12.3118 28.8421 12.7033 29.5754C13.9526 31.9178 15.4599 33.3097 16.974 33.7736V27.1583H11.6441ZM12.056 32.7529C11.5481 32.0876 11.0962 31.3813 10.7049 30.6414C10.1185 29.5262 9.63369 28.3605 9.25646 27.1583H5.1035C6.83929 29.6488 9.25188 31.5902 12.056 32.7529ZM8.6454 24.8951C8.23613 23.0349 7.99976 21.1409 7.93928 19.2371H2.30393C2.44425 21.2514 2.96252 23.1593 3.78859 24.8951H8.6454ZM24.1551 32.7529C26.9592 31.5902 29.3718 29.6488 31.1076 27.1583H26.9546C26.5774 28.3605 26.0926 29.5262 25.5062 30.6414C25.115 31.3814 24.6631 32.0877 24.1551 32.7529ZM19.2371 27.1583V33.7736C20.7535 33.3119 22.2585 31.9178 23.5078 29.5754C23.8993 28.8421 24.2546 28.0319 24.567 27.1583H19.2371ZM27.5657 24.8951H32.4225C33.2486 23.1593 33.7668 21.2514 33.9072 19.2371H28.2718C28.2114 21.1409 27.975 23.0349 27.5657 24.8951ZM33.9072 16.974C33.7699 15.0118 33.2664 13.0927 32.4225 11.316H27.5657C27.9595 13.0858 28.2039 14.9891 28.2718 16.974H33.9072ZM25.5062 5.56972C26.0652 6.61984 26.5518 7.78765 26.9546 9.05277H31.1076C29.3718 6.56232 26.9592 4.62094 24.1551 3.45816C24.6484 4.10091 25.1011 4.81155 25.5062 5.56972ZM24.567 9.05277C24.2734 8.22229 23.9194 7.41442 23.5078 6.63568C22.2585 4.29328 20.7535 2.90141 19.2371 2.43746V9.05277H24.567Z" fill="#CF1B5B" />
                        </g>
                        <defs>
                           <clipPath id="clip0_2_1286">
                              <rect width="36.2111" height="36.2111" fill="white" />
                           </clipPath>
                        </defs>
                     </svg>
                  </a>
               }
               {
                  modalInfo.linkedin &&
                  <a href={!modalInfo.linkedin.startsWith('http') ? `https://${modalInfo.linkedin}` : modalInfo.linkedin} target='_blank' rel='noreferrer'>
                     <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M2.29761 4.28196C2.29761 3.54647 2.58978 2.8411 3.10985 2.32103C3.62992 1.80096 4.33529 1.50879 5.07077 1.50879H32.7149C33.0794 1.5082 33.4404 1.5795 33.7773 1.71862C34.1142 1.85773 34.4204 2.06193 34.6782 2.31952C34.9361 2.57711 35.1407 2.88304 35.2801 3.21978C35.4196 3.55652 35.4913 3.91747 35.4911 4.28196V31.9261C35.4915 32.2907 35.42 32.6517 35.2807 32.9886C35.1415 33.3255 34.9371 33.6317 34.6794 33.8895C34.4217 34.1474 34.1157 34.3519 33.7788 34.4914C33.442 34.6308 33.081 34.7025 32.7164 34.7023H5.07077C4.70647 34.7023 4.34574 34.6305 4.00918 34.4911C3.67263 34.3516 3.36685 34.1472 3.10932 33.8895C2.85178 33.6319 2.64755 33.326 2.50827 32.9893C2.36899 32.6527 2.29741 32.2919 2.29761 31.9276V4.28196ZM15.4362 14.1646H19.9309V16.4217C20.5797 15.1242 22.2394 13.9564 24.7334 13.9564C29.5148 13.9564 30.6479 16.5409 30.6479 21.2831V30.0673H25.8092V22.3634C25.8092 19.6626 25.1604 18.1387 23.5128 18.1387C21.227 18.1387 20.2764 19.7818 20.2764 22.3634V30.0673H15.4362V14.1646ZM7.13783 29.8606H11.978V13.9564H7.13783V29.8591V29.8606ZM12.6706 8.76912C12.6797 9.18354 12.606 9.59562 12.4537 9.98116C12.3014 10.3667 12.0736 10.7179 11.7838 11.0143C11.4939 11.3106 11.1477 11.546 10.7657 11.7068C10.3836 11.8675 9.97321 11.9503 9.55869 11.9503C9.14416 11.9503 8.73381 11.8675 8.35172 11.7068C7.96963 11.546 7.62349 11.3106 7.33362 11.0143C7.04375 10.7179 6.81599 10.3667 6.6637 9.98116C6.51141 9.59562 6.43767 9.18354 6.4468 8.76912C6.46471 7.95566 6.80044 7.18155 7.38208 6.61258C7.96372 6.0436 8.74503 5.725 9.55869 5.725C10.3723 5.725 11.1537 6.0436 11.7353 6.61258C12.3169 7.18155 12.6527 7.95566 12.6706 8.76912Z" fill="#CF1B5B" />
                     </svg>
                  </a>
               }
               <div onClick={handleClose}>
                  <NewButton name='Close' color='white' bgColor='#CF1B5B' />
               </div>
            </div>
         </section>
      </div >
   )
}
